<template>
    <modal-component id="autorenewalModal" class="lightbox-autorenewal" :shown="shown" :handle-cancel="handleCancel">
        <template v-slot:header v-if="currentPromotion">
            {{ autorenewalIsActive ? i18n.deactivateAutorenewal : i18n.activateAutorenewal }}
        </template>
        <template v-slot:body v-if="currentPromotion">
            <template v-if="autorenewalIsActive">
                <p>
                    {{ i18n.areYouSure }} <strong>{{ i18n.autorenewalWillBeCanceled }}</strong> {{ i18n.autorenewalWillBeReactivated }}
                </p>
            </template>
            <template v-else>
                <p>
                    <span v-html="i18n.modalDescription"></span>
                    <br /> 
                    <strong>{{ i18n.doYouAgree }}</strong>
                </p>
            </template>
        </template>
        <template v-slot:footer v-if="currentPromotion">
            <button type="button" class="btn btn-outline-primary btn-block" @click="handleCancel">
                {{ i18n.cancel }}
            </button>
            <button type="button" class="btn btn-primary btn-block" @click="handleConfirm">
                {{ i18n.ok }}
            </button>
        </template>
    </modal-component>
</template>

<script>
// import Translations from "./insert-me-to-translate.vue";
import { getLightboxName } from '../../../utils';

import ModalComponent from '../../modal-component.vue'

export default {
    name: 'LightboxAutoRenewal',
    components: {
        ModalComponent,
    },
    data() {
        return {
            lightboxName: null,
            i18n: {
                doYouAgree: gettext('Do you agree?'),
                ok: gettext('Ok'),
                cancel: gettext('Cancel'),
                activateAutorenewal: gettext('Activate Auto-Renewal'),
                deactivateAutorenewal: gettext('Cancel Auto-Renewal'),
                areYouSure: gettext('Are you sure?'),
                autorenewalWillBeCanceled: gettext('Auto-renewal will be canceled.'),
                autorenewalWillBeReactivated: gettext('If you want to activate it again, you will have to do it manually.'),
                areYouSure: gettext('Are you sure?'),
                modalDescription: ''
            }
        };
    },
    computed: {
        shown() {
            return this.$store.getters['ui/lightboxManager/lightboxIsShown'](this.lightboxName);
        },
        currentPromotion() {
            return this.$store.getters['autorenewal/getPromotion'] ;
        },
        autorenewalIsActive() {
            return this.currentPromotion.autorenewalIsActive || false;
        },
        promotionDayOrNightLabel() {
            if(this.currentPromotion.timeRange === null) return '';
            
            if(this.currentPromotion.isNightProduct) {
                return 'Night';
            } else if (this.currentPromotion.timeRange === 0) {
                return 'Day';
            }

            return ''
        },
        availableAddons() {
            const availableAddons = this.currentPromotion.availableAddons;
            const selectedAddons = this.currentPromotion.selectedAddons;
            let addonsLabels = '';

            if (availableAddons.length) {
                addonsLabels = availableAddons.reduce((acc, addon) => {
                    if (!addon?.label || !addon?.type) return acc;

                    if(selectedAddons.includes(addon.type)) {
                        return addon.label ? `${addon.label} + ${acc}` : acc;
                    }
                    return acc;
                }, addonsLabels);
            }
            return addonsLabels || '';
        },   
        formattedPromotionName() {
            if(!this.currentPromotion) return '';

            return `${this.availableAddons} ${this.currentPromotion.name} ${this.promotionDayOrNightLabel}`;
        }
    },
    mounted() {
        this.lightboxName = getLightboxName({ el: this.$el })
    },
    watch: {
        /* 
        * The promotion that the user interacts with becomes the current promotion.
        * Therefore, it is necessary to observe the 'shown' method to update the modal description properly.
        */
        shown(newValue) {
            if(newValue) {
                const credits = this.currentPromotion.credits || 0;
                let modalDescription = ngettext(
                    'Every time the promotion %(promotion_name)s in the time slot %(time_hour)s auto-renews, <strong>%(number_of_credits)d credit</strong> will be charged.', 
                    'Every time the promotion %(promotion_name)s in the time slot %(time_hour)s auto-renews, <strong>%(number_of_credits)d credits</strong> will be charged.',
                credits);

                modalDescription = modalDescription.replace('%(promotion_name)s', `<strong>${this.formattedPromotionName}</strong>`);
                modalDescription = modalDescription.replace('%(time_hour)s', `<strong>${this.currentPromotion.time}</strong>`);
                modalDescription = modalDescription.replace('%(number_of_credits)d', `${credits}`);

                this.i18n.modalDescription = modalDescription;
            } else {
                this.i18n.modalDescription = '';
            }
        }
    },
    methods: {
        close({ clearCurrentPromotion = false }) {
            this.$store.dispatch("ui/lightboxManager/hide");

            if(clearCurrentPromotion) {
                this.$store.dispatch("autorenewal/clearCurrentPromotion");
            }
        },
        handleCancel() {
            this.close({ clearCurrentPromotion: true });
        },
        async handleConfirm() {
            this.close({ clearCurrentPromotion: false });
        
            const nextAutorenewalActiveState = !this.currentPromotion.autorenewalIsActive;

            try {
                const response = await this.$http.post(this.currentPromotion.apiUrl, 
                { 
                    private_code: this.currentPromotion.privateCode,
                    active: nextAutorenewalActiveState,
                }, 
                { 
                    headers: { 'X-CSRFToken': this.$cookies.get('csrftoken') } 
                });

                if (response.status === 200) {
                    this.$store.dispatch("autorenewal/setCurrentPromotion", {
                        ...this.currentPromotion,
                        autorenewalIsActive: nextAutorenewalActiveState,
                    });
                } else {
                    this.$store.dispatch("autorenewal/setCurrentPromotion", {
                        ...this.currentPromotion,
                        error: true,
                    })
                }
            } catch (error) {
                this.$store.dispatch("autorenewal/setCurrentPromotion", {
                    ...this.currentPromotion,
                    error,
                })
            }
        }
    }
}
</script>